<template>
  <div class="pageContol studentList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">设备管理</a>
          <i>></i>
          <a href="javascript:;">考场管理</a>
          <i>></i>
          <a href="javascript:;" @click="$router.back()">设备列表</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">模块列表</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="operationControl flexdc" style="align-items: flex-start">
          <el-button type="primary" class="bgc-bv" round @click="add_room_device_module">新增</el-button>
        </div>
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-table ref="multipleTable" :data="tableData" :height="tableHeight" size="small" tooltip-effect="dark"
              :header-cell-style="tableHeader" stripe>
              <el-table-column label="序号" align="center" type="index" :index="indexMethod" />
              <el-table-column label="模块类型" align="left" show-overflow-tooltip prop="serialPortDevice" width="150" >
                <template slot-scope="scope">
                  {{ scope.row.serialPortDevice ? $setDictionary("PA_AIO_BINDING_DEVICE", scope.row.serialPortDevice) : "" }}
                </template>
              </el-table-column>
              <el-table-column label="模块名称" align="left" show-overflow-tooltip prop="hardwareName" width="200" />
              <el-table-column label="串口地址" align="left" show-overflow-tooltip prop="serialPortName" width="100" />
              <el-table-column label="IP地址" align="left" show-overflow-tooltip prop="ipAddress" width="150" />
              <el-table-column label="IP地址" align="left" show-overflow-tooltip prop="correct" minWidth="300" />
              <el-table-column label="操作" align="center" width="220" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" style="padding: 0px 5px" size="mini" @click="deleteModule(scope.row)">删除</el-button>
                </template>
              </el-table-column>
              <Empty slot="empty" />
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Empty from "@/components/Empty.vue";
import PageNum from "@/components/PageNum.vue";
import List from "@/mixins/List";
export default {
  name: "practicalAssessmentSystem_systemManage_room_device_module",
  components: {
    Empty,
    PageNum,
  },
  mixins: [List],
  data() {
    return {
      // 上个页面传过来的数据
      lastPageData:{
        roomId: "",
        codeId: ""
      },
      // 检索数据
      formDate: {
        roomName: "", // 姓名
      },
    };
  },
  created() {
    this.lastPageData.roomId = this.$route.query.roomId;
    this.lastPageData.codeId = this.$route.query.codeId;
  },
  watch: {},
  computed: {},
  mounted() { },
  methods: {
    // 获取 - 列表数据
    getData(pageNum = 1) {
      const params = {
        pageNum: pageNum,
        pageSize: this.pageSize,
        codeId: this.$route.query.codeId,
        ...this.formDate
      };
      this.doFetch({
        url: "/biz/v2/room/device/module/page",
        params,
        pageNum,
      }, true, 10);
    },
    // 新增
    add_room_device_module(){
      this.$router.push({
        path: "/practicalAssessmentSystem/systemManage/add_room_device_module",
        query: this.lastPageData
      })
    },
    // 删除模块
    deleteModule(row) {
      this.$confirm('您确定删除当前模块配置信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("/biz/v2/room/device/module/del", {
          connectorId: row.connectorId
        }, 3000, true, 10).then((res) => {
          this.getData();
        });
      }).catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped></style>
